(() => {
  const parents = '.mw-apo-container, .myra-option-set-parent';
  const rowSelector = '.mw-option, .myra-option-set-row';
  const previewTemplate = document.getElementById('pp-vinyl-preview-template');
  const previews = new WeakMap();
  const activePreviews = new Set();
  const fonts = {
    'Times New Roman': '"Times New Roman", Times, serif',
    'Arial': 'Arial, Helvetica, sans-serif',
    'Segoe UI': '"Segoe UI", Arial, sans-serif',
    'Maven Pro': '"Puffin Inscription Maven Pro", Arial, sans-serif',
    'Felipa': '"Puffin Inscription Felipa", cursive',
    'Courier Prime': '"Puffin Inscription Courier Prime", "Courier New", monospace',
    'Cinzel': '"Puffin Inscription Cinzel", Georgia, serif',
    'Arimo': '"Puffin Inscription Arimo", Arial, sans-serif'
  };
  const colours = {
    'dark grey': '#53565a', 'dark blue': '#182b68', 'black gloss': '#111111',
    'matt black': '#202020', 'black': '#111111', 'pink': '#e559a0',
    'emerald green': '#008b60', 'forest green': '#195b3b', 'turquoise': '#00a6ad',
    'violet': '#713b92', 'mid blue': '#176bc0', 'sky blue': '#58b5df',
    'red': '#c92332', 'orange': '#ed731a', 'yellow': '#f3ce17', 'white': '#ffffff',
    'silver': '#b9bdc3', 'gold': '#b69a43'
  };
  let scheduled = false;
  let previewCount = 0;

  function prepareCaseArtwork(preview) {
    const svg = preview.querySelector('.pp-vinyl-preview__case');
    if (!svg) return;
    const prefix = 'pp-case-' + (++previewCount) + '-';
    const identifiers = new Map();
    svg.querySelectorAll('[id]').forEach(element => {
      const original = element.id;
      element.id = prefix + original;
      identifiers.set(original, element.id);
    });
    svg.querySelectorAll('[fill], [stroke], [filter]').forEach(element => {
      ['fill', 'stroke', 'filter'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        const match = value?.match(/^url\(#([^)]*)\)$/);
        if (match && identifiers.has(match[1])) element.setAttribute(attribute, 'url(#' + identifiers.get(match[1]) + ')');
      });
    });
  }

  function caseDimensionMm(dimension) {
    const description = previewTemplate?.dataset.caseDescription || '';
    const suffix = dimension === 'height' ? 'h|height|high' : 'w|width|wide';
    const after = description.match(new RegExp('\\b' + dimension + '\\s*[:=]?\\s*(\\d+(?:\\.\\d+)?)\\s*(mm|cm)?\\b', 'i'));
    const before = description.match(new RegExp('\\b(\\d+(?:\\.\\d+)?)\\s*(mm|cm)?\\s*(?:' + suffix + ')\\b', 'i'));
    const match = before || after;
    if (!match) return 240;
    const width = Number(match[1]) * (match[2]?.toLowerCase() === 'cm' ? 10 : 1);
    return width >= 30 && width <= 3000 ? width : 240;
  }

  function positionFor(value) {
    if (/top.*cent(?:re|er)|cent(?:re|er).*top/i.test(value)) return 'top';
    if (/bottom.*cent(?:re|er)|cent(?:re|er).*bottom/i.test(value)) return 'bottom';
    if (/vertical/i.test(value)) return 'vertical';
    if (/facing\s*in\b|inwards?/i.test(value)) return 'in';
    return 'out';
  }

  function centredInset(element, mode) {
    return mode === 'top' ? element.dataset.top : mode === 'bottom' ? element.dataset.bottom : element.dataset.left;
  }

  function selected(row) {
    const control = row?.querySelector('select');
    if (control) return control.value ? control.selectedOptions[0]?.textContent.trim() || '' : '';
    return row?.querySelector('input:checked')?.closest('label')?.textContent.trim() || '';
  }

  function fitPreview(state) {
    if (state.preview.hidden || !state.preview.isConnected) return;
    const mode = state.preview.dataset.position;
    const face = state.front.getBoundingClientRect();
    const inset = face.width * 10 / state.caseWidth;
    const edgeInset = face.height * 10 / state.caseHeight;
    const centred = mode === 'bottom' || mode === 'top';
    const width = centred ? face.width - inset * 2 : face.width - inset - face.width * .06;
    const height = centred ? face.height - edgeInset * 2 : face.height * .82;
    if (!width || !height) return;
    const signature = [width, height, inset, edgeInset, state.text.textContent, state.text.style.fontFamily, mode].join('|');
    if (state.fitSignature === signature) return;
    state.fitSignature = signature;
    state.text.style.fontSize = '30px';
    const bounds = state.text.getBoundingClientRect();
    const scale = Math.min(1, width / Math.max(1, bounds.width), height / Math.max(1, bounds.height));
    state.text.style.fontSize = Math.max(.5, Math.floor(30 * scale * 100) / 100).toFixed(2) + 'px';
    const fitted = state.text.getBoundingClientRect();
    state.text.style.left = (centred ? face.width / 2 : inset + fitted.width / 2).toFixed(3) + 'px';
    let textY = face.height / 2;
    if (mode === 'bottom') textY = face.height - edgeInset - fitted.height / 2;
    if (mode === 'top') textY = edgeInset + fitted.height / 2;
    state.text.style.top = textY.toFixed(3) + 'px';
    state.preview.dataset.insetMm = '10';
    state.preview.dataset.caseWidthMm = String(state.caseWidth);
    state.preview.dataset.caseHeightMm = String(state.caseHeight);
  }

  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
    entries.forEach(entry => {
      activePreviews.forEach(state => { if (state.front === entry.target) fitPreview(state); });
    });
  }) : null;

  function syncPreview(source) {
    if (!previewTemplate || source.family !== 'vinyl') return;
    let state = previews.get(source.control);
    if (!state?.preview.isConnected) {
      const preview = previewTemplate.content.querySelector('.pp-vinyl-preview').cloneNode(true);
      prepareCaseArtwork(preview);
      state = {
        control: source.control, preview,
        front: preview.querySelector('.pp-vinyl-preview__front'),
        text: preview.querySelector('.pp-vinyl-preview__text'),
        stage: preview.querySelector('.pp-vinyl-preview__stage'),
        summary: preview.querySelector('.pp-vinyl-preview__selection'),
        positionHint: preview.querySelector('.pp-vinyl-preview__position'),
        caseWidth: caseDimensionMm('width'),
        caseHeight: caseDimensionMm('height')
      };
      state.frontLabel = state.stage.getAttribute('aria-label');
      previews.set(source.control, state);
      activePreviews.add(state);
      resizeObserver?.observe(state.front);
    }
    const anchor = source.dependents[source.dependents.length - 1] || source.row;
    if (state.preview.parentElement !== anchor) anchor.append(state.preview);
    const fontRow = source.dependents.find(row => /font|style/.test(label(row)));
    const colourRow = source.dependents.find(row => /colou?r/.test(label(row)));
    const positionRow = source.dependents.find(row => /position|placement|alignment/.test(label(row)));
    const font = selected(fontRow);
    const colour = selected(colourRow);
    const position = selected(positionRow);
    const text = source.control.value.replace(/\r\n?/g, '\n');
    state.preview.hidden = !text.trim();
    if (state.text.textContent !== text) state.text.textContent = text;
    const family = fonts[font] || fonts.Arial;
    if (state.text.style.fontFamily !== family) state.text.style.fontFamily = family;
    const colourName = colour.toLowerCase().split(/\s*[-–]\s*/)[0].trim();
    const hex = colours[colourName] || '#111111';
    if (state.colour !== hex) { state.text.style.color = hex; state.colour = hex; }
    const mode = positionFor(position);
    if (state.preview.dataset.position !== mode) state.preview.dataset.position = mode;
    const insetLabel = state.preview.querySelector('.pp-vinyl-preview__inset');
    const insetText = centredInset(insetLabel, mode);
    if (insetLabel.textContent !== insetText) insetLabel.textContent = insetText;
    const positionHint = state.positionHint.dataset[mode] || '';
    if (state.positionHint.textContent !== positionHint) state.positionHint.textContent = positionHint;
    const light = /white|yellow|silver/.test(colourName);
    if (state.preview.dataset.light !== String(light)) state.preview.dataset.light = String(light);
    const summary = [font, colour, position].filter(Boolean).join(' · ');
    if (state.summary.textContent !== summary) state.summary.textContent = summary;
    const description = [state.frontLabel, text, summary, state.positionHint.textContent, state.preview.querySelector('.pp-vinyl-preview__inset').textContent].filter(Boolean).join(': ');
    if (state.stage.getAttribute('aria-label') !== description) state.stage.setAttribute('aria-label', description);
    requestAnimationFrame(() => fitPreview(state));
  }

  function label(row) {
    return (row.querySelector('.mw-text--style-strong, .myra-label-on-product')?.textContent || '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function family(text) {
    if (/inscription|plaque/.test(text)) return 'inscription';
    if (/vinyl|lettering|(?:team|club) name/.test(text)) return 'vinyl';
    if (/personali[sz]ation|custom (?:text|name)/.test(text)) return 'personalisation';
    if (/(?:engraving|engraved) text/.test(text)) return 'engraving';
    return '';
  }

  function textControl(row) {
    return row.querySelector('textarea, input.mw-option__control[type="text"], input.myra-textInput, input[type="text"][name^="mw_opts"]');
  }

  function sourceFor(row) {
    const control = textControl(row);
    const text = label(row);
    const group = family(text);
    if (!control || !group || /font|colou?r|position|placement|alignment/.test(text)) return null;
    return { row, control, family: group, dependents: [] };
  }

  function sync(parent) {
    const rows = Array.from(parent.children).filter(row => row.matches(rowSelector));
    const sources = rows.map(sourceFor).filter(Boolean);
    const assigned = new Set();
    const endings = new Set();
    let previousSource;

    rows.forEach(row => {
      const ownSource = sources.find(source => source.row === row);
      if (ownSource) {
        previousSource = ownSource;
        return;
      }
      const text = label(row);
      if (!/font|colou?r|position|placement|alignment|preview|style|(?:text|lettering) size/.test(text)) return;
      if (row.querySelector('input[type="file"]')) return;
      const group = family(text);
      let source = group && previousSource?.family === group ? previousSource : group ? sources.find(item => item.family === group) : null;
      if (!source && group === 'inscription') source = sources.find(item => item.family === 'personalisation');
      if (!source && group === 'vinyl' && previousSource?.family === 'personalisation') source = previousSource;
      if (!source && /^(?:font(?: style)?|style|colou?r|position|placement|alignment|preview|text size|lettering size)$/.test(text)) {
        source = previousSource;
      }
      if (!source) return;
      source.dependents.push(row);
      assigned.add(row);
    });

    sources.forEach(source => {
      const hasText = source.control.value.trim().length > 0;
      source.row.classList.add('pp-lettering-start');
      source.dependents.forEach(row => row.classList.toggle('pp-lettering-hidden', !hasText));
      source.row.querySelectorAll('.pp-inscription-preview, .pp-lettering-preview').forEach(preview => {
        preview.classList.toggle('pp-lettering-hidden', !hasText);
      });
      endings.add(hasText && source.dependents.length ? source.dependents[source.dependents.length - 1] : source.row);
      if (source.family === 'vinyl') syncPreview(source);
      else if (source.family === 'personalisation' && source.dependents.some(row => family(label(row)) === 'vinyl')) syncPreview({ ...source, family: 'vinyl' });
    });

    rows.forEach(row => {
      if (!assigned.has(row)) row.classList.remove('pp-lettering-hidden');
      row.classList.toggle('pp-lettering-end', endings.has(row));
      if (!sources.some(source => source.row === row)) row.classList.remove('pp-lettering-start');
    });
  }

  function scan() {
    scheduled = false;
    activePreviews.forEach(state => {
      if (!state.control.isConnected || !state.preview.isConnected) {
        resizeObserver?.unobserve(state.front);
        if (!state.control.isConnected) state.preview.remove();
        activePreviews.delete(state);
      }
    });
    document.querySelectorAll(parents).forEach(sync);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  // APO's custom dropdown emits a non-bubbling change on the original select.
  // Capture it without rescanning when a customer only opens the dropdown.
  ['input', 'change'].forEach(eventName => document.addEventListener(eventName, event => {
    const parent = event.target.closest?.(parents);
    if (parent) schedule();
  }, true));
  new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.closest?.(parents) || Array.from(mutation.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(parents) || node.querySelector(parents))
    ))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['selected', 'aria-selected', 'value'] });
  document.fonts?.addEventListener('loadingdone', () => {
    activePreviews.forEach(state => { state.fitSignature = ''; fitPreview(state); });
  });
  window.addEventListener('resize', schedule);
  document.addEventListener('reset', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  scan();
})();






